"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var domain = 'https://beacon-v2.helpscout.net';
/* eslint:disable */

var loadScript = function loadScript() {
  if (window.Beacon) return;

  (function (e, t, n) {
    function a() {
      var _e$parentNode;

      var e = t.getElementsByTagName('script')[0],
          n = t.createElement('script');
      n.async = !0, n.src = domain, (_e$parentNode = e.parentNode) === null || _e$parentNode === void 0 ? void 0 : _e$parentNode.insertBefore(n, e);
    }

    if ( //eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.Beacon = n = function n(t, _n, a) {
      e.Beacon.readyQueue.push({
        method: t,
        options: _n,
        data: a
      });
    }, n.readyQueue = [], 'complete' === t.readyState) return a();
    e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, !1); //eslint-disable-next-line @typescript-eslint/no-empty-function
  })(window, document, window.Beacon || function () {});
};
/* eslint:enable */


var load = function load(_ref) {
  var providerKey = _ref.providerKey,
      setState = _ref.setState;
  loadScript();
  window.Beacon('init', providerKey);
  setTimeout(function () {
    return setState('complete');
  }, 2000);
};

var open = function open() {
  return window.Beacon('open');
};

var close = function close() {
  return window.Beacon('close');
};

var _default = {
  domain: domain,
  load: load,
  open: open,
  close: close
};
exports.default = _default;